class EmptyElemChecker {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._settings = JSON.parse(this._elem.dataset.emptyElemChecker)
        this._elems = document.querySelectorAll(this._settings.selector)
    }

    onInit () {
        for (let elem of this._elems) {
            if (elem.innerHTML.trim().length === 0) {
                elem.classList.add('elem--is-empty')
            }
        }
    }
}

export default EmptyElemChecker



// WEBPACK FOOTER //
// ./src/resources/scripts/components/EmptyElemChecker.js